import Vue from 'vue'

export default Vue.extend({
  template: `
    <span v-if="this.params.data.id !== userId">
      <a-tooltip placement="top" title="Edit">
        <a @click="() => editUser()">
          <i class="fa fa-pencil" style="font-size: 20px;cursor: pointer;color: #007bff; margin-left: 10px;"/>
        </a>
      </a-tooltip>
    </span>
    `,
  data: function() {
    return {
      value: '',
      isShow: false,
      userId: null,
    }
  },
  beforeMount() {
    const user = JSON.parse(localStorage.getItem('userDetails'))
    this.userId = user.id
    this.value = this.params.value
  },
  methods: {
    editUser() {
      this.isShow = true
      this.params.api.startEditingCell({
        rowIndex: this.params.rowIndex,
        colKey: 'role',
      })
    },
  },
})
